/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesdropuploading2Inputs */

const en_filesdropuploading2 = /** @type {(inputs: Filesdropuploading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading…`)
};

const pt_filesdropuploading2 = /** @type {(inputs: Filesdropuploading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar…`)
};

/**
* | output |
* | --- |
* | "Uploading…" |
*
* @param {Filesdropuploading2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesdropuploading2 = /** @type {((inputs?: Filesdropuploading2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesdropuploading2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesdropuploading2(inputs)
	return pt_filesdropuploading2(inputs)
});
export { filesdropuploading2 as "filesDropUploading" }